import { StyleSheet } from "react-native";

const styles = StyleSheet.create({
    activityLoaderContainer: {
        position: 'absolute', 
        backgroundColor: "#FFF", 
        width:"100%", 
        height: "100%", 
        justifyContent: 'center',
    },
});
  
export default styles;